module.exports = __webpack_public_path__ + "img/recessionprooffunding-square.11d0e034.png";